import { showToast } from '../../application/utils/toast.util';
import {validations} from '../../application/messages';

import {client} from '../../core/stores';
import {
  MUTATION_COURSE,
  MUTATION_UNIT_BY_COURSE_MODULE,
  MUTATION_COURSE_MODULE,
} from '../../core/graphql/types';

export function MutateCourse(course, setSubmitting, setProgress): Promise<any> {
  return new Promise((resolve, reject) => {
    setSubmitting(true);
    const errors = {};
    const {
      id,
      title,
      description,
      status,
      coverUrl,
      posterUrl,
      premiumAccessThroughAnyPlan,
      programIds,
      courseCategoryId,
    } = course;
    if (!title) errors['title'] = validations.required;
    if (!description) errors['description'] = validations.required;
    course.units.map((unit, index) => {
      if (!unit.title || !unit.description) {
        if (!errors['units']) errors['units'] = [];
        if (!errors['units'][index]) errors['units'][index] = {};
        if (!unit.title) errors['units'][index]['title'] = validations.required;
        if (!unit.description)
          errors['units'][index]['description'] = validations.required;
      }
    });
    if (Object.entries(errors).length !== 0) {
      setSubmitting(false);
      reject(errors);
      return false;
    }

    const variables = {
      id,
      title,
      description,
      courseCategoryId,
      status,
      premiumAccessThroughAnyPlan,
      programIds,
      coverUrl,
      posterUrl,
    };
    client('account')
      .mutate({
        mutation: MUTATION_COURSE,
        variables,
      })
      .then(({data}) => {
        const {course} = data;
        setSubmitting(false);
        resolve({status: 'success', ...course});
      })
      .catch((err) => {
        console.log('error => ', err);
        const errorMessage = err.graphQLErrors
          .map((error) => error.message)
          .join(',');
        showToast({html: 'Houve um erro na sua solicitação.'});
        showToast({html: errorMessage});
        setSubmitting(false);
        reject({status: 'error', message: errorMessage});
      });
  });
}

export function MutateCourseModule(
  course,
  courseModule,
  setSubmitting,
  setProgress,
): Promise<any> {
  return new Promise((resolve, reject) => {
    setSubmitting(true);
    const errors = {};
    const {id, title, description, order, _destroy} = courseModule;
    if (!title && !_destroy) errors['title'] = validations.required;

    if (Object.entries(errors).length !== 0) {
      setSubmitting(false);
      reject(errors);
      return false;
    }

    client('account')
      .mutate({
        mutation: MUTATION_COURSE_MODULE,
        variables: {
          courseId: course.id,
          id,
          title,
          description,
          order,
          _destroy,
        },
      })
      .then(({data}) => {
        const {courseModule} = data;
        setSubmitting(false);
        resolve({status: 'success', ...courseModule});
      })
      .catch((err) => {
        const errorMessage = err.graphQLErrors
          .map((error) => error.message)
          .join(',');
        showToast({html: 'Houve um erro na sua solicitação.'});
        showToast({html: errorMessage});
        setSubmitting(false);
        reject({status: 'error', message: errorMessage});
      });
  });
}

export function MutateUnitByCourseModule(
  courseModule,
  unit,
  setSubmitting,
  setProgress,
): Promise<any> {
  return new Promise((resolve, reject) => {
    setSubmitting(true);
    const errors = {};

    const {
      id,
      title,
      description,
      coverUrl,
      posterUrl,
      participationType,
      videoUrl,
      audioUrl,
      order,
      unitType,
      _destroy,
    } = unit;
    if (!title) errors['title'] = validations.required;
    if (!description) errors['description'] = validations.required;
    if (!unitType) errors['unitType'] = validations.required;

    if (Object.entries(errors).length !== 0) {
      setSubmitting(false);
      reject(errors);
      return false;
    }

    client('account')
      .mutate({
        mutation: MUTATION_UNIT_BY_COURSE_MODULE,
        variables: {
          courseModuleId: courseModule.id,
          id,
          title,
          description,
          unitType,
          participationType,
          _destroy,
          order,
          coverUrl,
          posterUrl,
          videoUrl,
          audioUrl,
        },
      })
      .then(({data}) => {
        const {unitByCourseModule} = data;
        setSubmitting(false);
        resolve({status: 'success', ...unitByCourseModule});
      })
      .catch((err) => {
        const errorMessage = err.graphQLErrors
          .map((error) => error.message)
          .join(',');
        showToast({html: 'Houve um erro na sua solicitação.'});
        showToast({html: errorMessage});
        setSubmitting(false);
        reject({status: 'error', message: errorMessage});
      });
  });
}
